import React from 'react';
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';

const SidebarContent = ({
  onClick, changeToLight, changeToDark, sidebarCollapse,
}) => {
  const hideSidebar = () => {
    onClick();
  };

  return (
    <div className="sidebar__content">
      <ul className="sidebar__block">
        <SidebarLink title="Dashboard"
          icon="home"
          route="/dashboard"
          onClick={hideSidebar}
        />
      </ul>
      <ul className="sidebar__block">
        <SidebarLink
          title="Products"
          icon="cart"
          route="/products"
          onClick={hideSidebar}
        />
      </ul>
      <ul className="sidebar__block">
        <SidebarCategory title="Amazon" icon="diamond" sidebarCollapse={sidebarCollapse}>
          <SidebarCategory title="Revenue" sidebarCollapse={sidebarCollapse}>
            <SidebarLink title="Revenue" route="/amazon/revenue" onClick={hideSidebar} />
            <SidebarLink
              title="This month sales vs previous"
              route="/amazon/compare/month"
              onClick={hideSidebar}
            />
            <SidebarLink
              title="Category (SKU) sales by month"
              route="/amazon/sales/category-by-month"
              onClick={hideSidebar}
            />
             <SidebarLink
              title="Category (SKU) sales by year"
              route="/amazon/sales/category-by-year"
              onClick={hideSidebar}
            />
            <SidebarLink
              title="Category (SKU) sales by day"
              route="/amazon/sales/category-by-day"
              onClick={hideSidebar}
            />
            <SidebarLink title="Sales breakdown" route="/amazon/sales-breakdown" onClick={hideSidebar} />
            <SidebarLink title="Sales by region" route="/sales-by-region" onClick={hideSidebar} />
            <SidebarLink title="AOV" route="/amazon/aov" onClick={hideSidebar} />
            <SidebarLink title="Profit" route="/amazon/profit" onClick={hideSidebar} />
            <SidebarLink title="Lifetime value" route="/amazon/lifetime-value" onClick={hideSidebar} />
          </SidebarCategory>
          <SidebarCategory title="Performance" icon="" sidebarCollapse={sidebarCollapse}>
            <SidebarLink title="Performance By SKU" icon="" route="/performance/by/sku" onClick={hideSidebar} />
          </SidebarCategory>
          <SidebarLink title="Customers" icon="" route="/amazon/customer" onClick={hideSidebar} />
          <SidebarLink title="Orders" icon="" route="/amazon/order" onClick={hideSidebar} />          
          <SidebarCategory title="Subscriptions" icon="" sidebarCollapse={sidebarCollapse}>
            <SidebarLink disabled title="Subscription box sales" route="/notimplementedinfo" onClick={hideSidebar} />
            <SidebarLink title="Subscribers" route="/amazon/subscribers" onClick={hideSidebar} />
            <SidebarLink
              title="Subscribers by category/sku"
              route="/amazon/subscribers/category"
              onClick={hideSidebar}
            />
            <SidebarLink
              title="Revenue from subscription"
              route="/amazon/revenue-from-subscription"
              onClick={hideSidebar}
            />

            <SidebarLink
              title="Monthly subscription orders"
              route="/amazon/monthly-order-subscription"
              onClick={hideSidebar}
            />
          </SidebarCategory>
          <SidebarCategory title="Inventory" icon="" sidebarCollapse={sidebarCollapse}>
            <SidebarLink title="Month end inventory" route="/amazon/month-end-inventory" onClick={hideSidebar} />
            <SidebarLink title="FBA Inventory Forecast" route="/amazon/inventory-fba-forecast" onClick={hideSidebar} />
            <SidebarLink title="Best SKUs" route="/amazon/category/sales" onClick={hideSidebar} />
          </SidebarCategory>
          <SidebarLink title="Promotions" route="/amazon/promotion-by-revenue" onClick={hideSidebar} />
          <SidebarLink title="Promotion Prime" route="/amazon/promotion-prime" onClick={hideSidebar} />
          <SidebarCategory title="Advertising" icon="" sidebarCollapse={sidebarCollapse}>
            <SidebarLink disabled title="Adv Account" route="/maps/google_map" onClick={hideSidebar} />
            <SidebarLink title="Adv Campaign" route="/amazon/adv-campaign" onClick={hideSidebar} />
            <SidebarLink
              title="Adv Budget Performance"
              route="/amazon/adv-budget-performance"
              onClick={hideSidebar}
            />
            <SidebarLink
              title="Adv Sales"
              route="/amazon/adv-sales"
              onClick={hideSidebar}
            />
            <SidebarLink
              title="Adv Products"
              route="/amazon/adv-products"
              onClick={hideSidebar}
            />
            <SidebarLink
              title="Adv Keywords"
              route="/amazon/adv-keywords"
              onClick={hideSidebar}
            />
          </SidebarCategory>
          <SidebarCategory title="Reports" icon="" sidebarCollapse={sidebarCollapse}>
            <SidebarLink title="Search Position tracker" route="/report/searchPositionTracker/detail" />
            <SidebarLink title="New/Return customer" route="/amazon/new-return-customer" />
            <SidebarLink title="Best times" route="/amazon/reports/best-times" />
            <SidebarLink
              title="Page Traffic ( views vs sales ) with conversion"
              route="/page/traffic/conversion"
              onClick={hideSidebar}
            />
            <SidebarLink title="Fullfillment Shipment" icon="" route="/upload/fullfillment/shipment"
           onClick={hideSidebar} />
            <SidebarLink title="Basket Analysis" route="/amazon/basket/analysis" />
            <SidebarLink title="Repurchase rate" route="/amazon/repurchase/rate" />
            <SidebarLink title="Virtual Bundle Sales" route="/amazon/reports/VirtualBundleSales" />
            <SidebarLink title="Import"
              route="/virtualbundlesales/details"
              onClick={hideSidebar}
            />    
            <SidebarLink title="Customer Transition" route="/amazon/Customer-Transition" onClick={hideSidebar} />
            <SidebarLink disabled title="Web to Amazon" route="/ui/alerts" onClick={hideSidebar} />
            <SidebarLink disabled title="Amazon to Web" route="/ui/alerts" onClick={hideSidebar} />
            <SidebarLink title="Tax" route="/amazon/tax" onClick={hideSidebar} />
          </SidebarCategory>
          <SidebarLink title="Return Refund" route="/return-refund" onClick={hideSidebar} />
        </SidebarCategory>

      </ul>
      <ul className="sidebar__block">
        <SidebarCategory title="Shopify" icon="book" sidebarCollapse={sidebarCollapse}>
          <SidebarCategory title="Revenue" sidebarCollapse={sidebarCollapse}>
            <SidebarLink title="Revenue" route="/shopify/revenue" onClick={hideSidebar} />
            <SidebarLink
              disabled 
              title="Revenue by channel"
              route="/forms/redux_form/check_form_controls"
              onClick={hideSidebar}
            />
            <SidebarLink
              title="This month sales vs previous"
              route="/shopify/compare/month"
              onClick={hideSidebar}
            />
            <SidebarLink
              title="Category (SKU) sales by month"
              route="/shopify/sales/category-by-month"
              onClick={hideSidebar}
            />
            <SidebarLink
              title="Category (SKU) sales by day"
              route="/shopify/sales/category-by-day"
              onClick={hideSidebar}
            />
            {/* disabled explictly */}
            <SidebarLink
              title="Sales breakdown" route="/shopify/sales-breakdown" onClick={hideSidebar} />
            <SidebarLink disabled title="Sales by region"
              route="/forms/redux_form/form_validation" onClick={hideSidebar} />
            <SidebarLink
              title="AOV" route="/shopify/aov" onClick={hideSidebar} />
            <SidebarLink
              title="Profit" route="/shopify/profit" onClick={hideSidebar} />
            {/* disabled explictly */}
            <SidebarLink              
              title="Lifetime value" route="/shopify/lifetime-value" onClick={hideSidebar} />
          </SidebarCategory>
          {/* disabled explictly */}
          <SidebarLink
            disabled
            title="Customers" icon="" route="/shopify/customer" onClick={hideSidebar} />
          {/* disabled explictly */}
          <SidebarLink
            disabled
            title="Orders" icon="" route="/shopify/order" onClick={hideSidebar} />
          <SidebarCategory title="Subscriptions" icon="" sidebarCollapse={sidebarCollapse}>
            <SidebarLink disabled title="Subscribers" route="/subscribers" onClick={hideSidebar} />
            <SidebarLink disabled
              title="Subscribers by category/sku"
              route="/forms/redux_form/form_picker"
              onClick={hideSidebar}
            />
            <SidebarLink disabled
              title="Revenue from subscription"
              route="/forms/redux_form/form_validation"
              onClick={hideSidebar}
            />
            <SidebarLink disabled
              title="Monthly subscription orders"
              route="/forms/redux_form/mask_form"
              onClick={hideSidebar}
            />
          </SidebarCategory>
          <SidebarLink disabled
            title="Promotions"
            route="/maps/map_with_request"
            onClick={hideSidebar}
          />
          <SidebarCategory title="Advertising" icon="" sidebarCollapse={sidebarCollapse}>
            <SidebarLink disabled
              title="Advertising KPI(Facebook)"
              route="/charts/charts_js"
              onClick={hideSidebar}
            />
            <SidebarLink disabled
              title="Advertising KPI(Google)"
              route="/charts/charts_js"
              onClick={hideSidebar}
            />
            <SidebarLink disabled title="Adv sales" route="/charts/recharts" onClick={hideSidebar} />
          </SidebarCategory>
          <SidebarCategory title="Reports" icon="" sidebarCollapse={sidebarCollapse}>
            <SidebarLink
              title="New/Return customer" route="/shopify/new-return-customer" onClick={hideSidebar} />
            <SidebarLink
              title="Best times"
              route="/shopify/reports/best-times"
              onClick={hideSidebar}
            />
            <SidebarLink disabled
              title="Page Traffic ( views vs sales ) with conversion"
              route="/maps/map_with_request"
              onClick={hideSidebar}
            />
            <SidebarLink
              title="Basket Analysis"
              route="/shopify/basket/analysis"
              onClick={hideSidebar}
            />
            <SidebarLink
              title="Repurchase rate"
              route="/shopify/repurchase/rate"
              onClick={hideSidebar}
            />
<SidebarLink
              title="Session by referrer"
              route="/session/by/referrer"
              onClick={hideSidebar}
            /><SidebarLink
            title="Sales by referrer"
            route="/sales/by/referrer"
            onClick={hideSidebar}
          />
          <SidebarLink
            title="Sales by channel"
            route="/sales/by/channel"
            onClick={hideSidebar}
          />
          </SidebarCategory>              
          
        </SidebarCategory>

      </ul>
      <ul className="sidebar__block">
        <SidebarCategory title="Wholesale" icon="envelope" sidebarCollapse={sidebarCollapse}>
          <SidebarCategory title="Revenue" sidebarCollapse={sidebarCollapse}>
            <SidebarLink title="Revenue" route="/wholesale/revenue" onClick={hideSidebar} />
            <SidebarLink
              title="Revenue by Customers"
              route="/wholesale/revenue-customers"
              onClick={hideSidebar}
            />
            <SidebarLink
              title="SKU sales by month"
              route="/wholesale/sales/category-by-month"
              onClick={hideSidebar}
            />
            <SidebarLink
              title="SKU sales by day"
              route="/wholesale/sales/category-by-day"
              onClick={hideSidebar}
            />
            <SidebarLink title="Sales breakdown" route="/wholesale/sales-breakdown" onClick={hideSidebar} />
            <SidebarLink title="Sales by region" disabled
              route="/forms/redux_form/form_validation" onClick={hideSidebar} />
            <SidebarLink title="AOV" route="/wholesale/aov" onClick={hideSidebar} />
            <SidebarLink title="Profit" route="/wholesale/profit" onClick={hideSidebar} />
            <SidebarLink title="Lifetime value" route="/forms/redux_form/material_form" onClick={hideSidebar} />
          </SidebarCategory>
          <SidebarCategory title="POS" sidebarCollapse={sidebarCollapse}>
            <SidebarLink title="Sales" route="/POS/sales" onClick={hideSidebar} />
            <SidebarLink title="Sales by Product"
              route="/POS/sales-by-product"
              onClick={hideSidebar}
            />
            <SidebarLink title="Sales Breakdown by Product"
              route="/pos/sales-breakdown-by-product"
              onClick={hideSidebar}
            />
            <SidebarLink title="Import"
              route="/pos/details"
              onClick={hideSidebar}
            />            
            {/* <SidebarLink
              title="SKU sales by month"
              route="/wholesale/sales/category-by-month"
              onClick={hideSidebar}
            />
            <SidebarLink
              title="SKU sales by day"
              route="/wholesale/sales/category-by-day"
              onClick={hideSidebar}
            /> */}
            {/* <SidebarLink title="Sales breakdown" route="/wholesale/sales-breakdown" onClick={hideSidebar} />
            <SidebarLink title="Sales by region" disabled
              route="/forms/redux_form/form_validation" onClick={hideSidebar} />
            <SidebarLink title="AOV" route="/wholesale/aov" onClick={hideSidebar} />
            <SidebarLink title="Profit" route="/wholesale/profit" onClick={hideSidebar} />
            <SidebarLink title="Lifetime value" route="/forms/redux_form/material_form" onClick={hideSidebar} /> */}
          </SidebarCategory>
          <SidebarLink title="Customers" icon="" route="/wholesale/customer" onClick={hideSidebar} />
          <SidebarLink title="Orders" icon="" route="/wholesale/order" onClick={hideSidebar} />
        </SidebarCategory>

      </ul>
      <ul className="sidebar__block">
        <SidebarCategory title="Ebay" icon="diamond" sidebarCollapse={sidebarCollapse}>
          <SidebarCategory title="Revenue" sidebarCollapse={sidebarCollapse}>
            <SidebarLink title="Revenue" route="/ebay/revenue" onClick={hideSidebar} />
            <SidebarLink
              title="Category (SKU) sales by day"
              route="/ebay/sales/category-by-day"
              onClick={hideSidebar}
            />
            {/* <SidebarLink
              title="This month sales vs previous"
              route="/amazon/compare/month"
              onClick={hideSidebar}
            />
            <SidebarLink
              title="Category (SKU) sales by month"
              route="/amazon/sales/category-by-month"
              onClick={hideSidebar}
            />
            
            <SidebarLink title="Sales breakdown" route="/amazon/sales-breakdown" onClick={hideSidebar} />
            <SidebarLink title="Sales by region" route="/sales-by-region" onClick={hideSidebar} />
            <SidebarLink title="AOV" route="/amazon/aov" onClick={hideSidebar} />
            <SidebarLink title="Profit" route="/amazon/profit" onClick={hideSidebar} />
            <SidebarLink title="Lifetime value" route="/amazon/lifetime-value" onClick={hideSidebar} />
          </SidebarCategory>
          <SidebarLink title="Customers" icon="" route="/amazon/customer" onClick={hideSidebar} />
          <SidebarLink title="Orders" icon="" route="/amazon/order" onClick={hideSidebar} />
          <SidebarCategory title="Subscriptions" icon="" sidebarCollapse={sidebarCollapse}>
            <SidebarLink disabled title="Subscription box sales" route="/notimplementedinfo" onClick={hideSidebar} />
            <SidebarLink title="Subscribers" route="/amazon/subscribers" onClick={hideSidebar} />
            <SidebarLink
              title="Subscribers by category/sku"
              route="/amazon/subscribers/category"
              onClick={hideSidebar}
            />
            <SidebarLink
              title="Revenue from subscription"
              route="/amazon/revenue-from-subscription"
              onClick={hideSidebar}
            />

            <SidebarLink
              title="Monthly subscription orders"
              route="/amazon/monthly-order-subscription"
              onClick={hideSidebar}
            />
          </SidebarCategory>
          <SidebarCategory title="Inventory" icon="" sidebarCollapse={sidebarCollapse}>
            <SidebarLink title="Month end inventory" route="/amazon/month-end-inventory" onClick={hideSidebar} />
            <SidebarLink title="FBA Inventory Forecast" route="/amazon/inventory-fba-forecast" onClick={hideSidebar} />
            <SidebarLink title="Best SKUs" route="/amazon/category/sales" onClick={hideSidebar} />
          </SidebarCategory>
          <SidebarLink title="Promotions" route="/amazon/promotion-by-revenue" onClick={hideSidebar} />
          <SidebarCategory title="Advertising" icon="" sidebarCollapse={sidebarCollapse}>
            <SidebarLink disabled title="Adv Account" route="/maps/google_map" onClick={hideSidebar} />
            <SidebarLink title="Adv Campaign" route="/amazon/adv-campaign" onClick={hideSidebar} />
            <SidebarLink
              title="Adv Budget Performance"
              route="/amazon/adv-budget-performance"
              onClick={hideSidebar}
            />
            <SidebarLink
              title="Adv Sales"
              route="/amazon/adv-sales"
              onClick={hideSidebar}
            />
            <SidebarLink
              title="Adv Products"
              route="/amazon/adv-products"
              onClick={hideSidebar}
            />
            <SidebarLink
              title="Adv Keywords"
              route="/amazon/adv-keywords"
              onClick={hideSidebar}
            />
          </SidebarCategory>
          <SidebarCategory title="Reports" icon="" sidebarCollapse={sidebarCollapse}>
            <SidebarLink disabled title="Search Position tracker" route="/notimplementedinfo" />
            <SidebarLink title="New/Return customer" route="/amazon/new-return-customer" />
            <SidebarLink title="Best times" route="/amazon/reports/best-times" />
            <SidebarLink
              title="Page Traffic ( views vs sales ) with conversion"
              route="/page/traffic/conversion"
              onClick={hideSidebar}
            />
            <SidebarLink title="Basket Analysis" route="/amazon/basket/analysis" />
            <SidebarLink title="Repurchase rate" route="/amazon/repurchase/rate" />
            <SidebarLink disabled title="Virtual Bundle Sales" route="/notimplementedinfo" />
            <SidebarLink disabled title="Web to Amazon" route="/ui/alerts" onClick={hideSidebar} />
            <SidebarLink disabled title="Amazon to Web" route="/ui/alerts" onClick={hideSidebar} /> */}
          </SidebarCategory>
        </SidebarCategory>

      </ul>
      <ul className="sidebar__block">
        <SidebarCategory title="Korea" icon="phone" sidebarCollapse={sidebarCollapse}>
            <SidebarLink
              title="Revenue"
              route="/korea/revenue"
              onClick={hideSidebar}
            />
            <SidebarLink
              title="Revenue by Customers"
              route="/korea/revenue-customer"
              onClick={hideSidebar}
            />            
        </SidebarCategory>
      </ul>
     
    </div>
  );
};

SidebarContent.propTypes = {
  changeToDark: PropTypes.func.isRequired,
  changeToLight: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  sidebarCollapse: PropTypes.bool,
};

SidebarContent.defaultProps = {
  sidebarCollapse: false,
};

export default SidebarContent;
